import React from "react"
import g from "glamorous"
import { css } from "glamor"
import Link from "gatsby-link"

const NavLinkStyle = css({
    textDecoration: `none`,
    textTransform: `uppercase`,
    margin: `0 0.5em`,
    fontSize: `0.75em`,
    ':last-child': {
        marginRight: 0
    }
})

const Footer = g.footer({
    borderTop: `2px solid black`,
    textAlign: `right`,
    padding: `2em 0`
})

const MenuList = g.ul({
    listStyleType: `none`
})

const MenuItem = g.li({
    display: `inline`
})

export default () =>
    <Footer>
        <MenuList>
            <MenuItem>
                <a href="https://www.instagram.com/geoframsay/?hl=en" target="_blank" className={NavLinkStyle}>Instagram</a>
            </MenuItem>
        </MenuList>
    </Footer>


// WEBPACK FOOTER //
// ./src/components/footer.jsx